import React from 'react';
import { Badge } from './ui/badge';
import { Heart, Award, Leaf, Users } from 'lucide-react';

const About = () => {
  const features = [
    {
      icon: Heart,
      title: '100% Artesanal',
      description: 'Cada doce é preparado manualmente com dedicação e carinho'
    },
    {
      icon: Award,
      title: 'Ingredientes Premium',
      description: 'Utilizamos apenas ingredientes selecionados de alta qualidade'
    },
    {
      icon: Leaf,
      title: 'Sem Conservantes',
      description: 'Produto artesanal feito sem conservantes artificiais'
    },
    {
      icon: Users,
      title: 'Feito com Amor',
      description: 'Tradição portuguesa em cada brigadeiro e bombom'
    }
  ];

  return (
    <section id="about" className="py-20 bg-gradient-to-b from-amber-50 to-white">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Left side - Image */}
          <div className="relative">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <img 
                src="/images/second.png"
                alt="Sobre Ser Tão Doce"
                className="w-full h-[500px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-amber-900/40 to-transparent"></div>
            </div>
            {/* Logo overlay */}
            <div className="absolute top-8 left-8 bg-white/95 backdrop-blur-sm rounded-2xl p-4 shadow-lg">
              <img 
                src="https://customer-assets.emergentagent.com/job_1d505a5f-a544-4c6e-8862-fec39bdf81d8/artifacts/gj3rnkah_image.png"
                alt="Ser Tão Doce Logo"
                className="w-24 h-24 object-contain"
              />
            </div>
          </div>

          {/* Right side - Content */}
          <div className="space-y-8">
            <div>
              <Badge className="mb-4 bg-amber-100 text-amber-800 hover:bg-amber-200">
                Nossa História
              </Badge>
              <h2 className="text-4xl md:text-5xl font-bold text-amber-950 mb-6">
                Deixe sua vida mais doce
              </h2>
              <p className="text-lg text-amber-800 leading-relaxed mb-4">
                A <span className="font-bold">Ser Tão Doce</span> nasceu da paixão por criar momentos especiais através da confeitaria artesanal portuguesa.
              </p>
              <p className="text-lg text-amber-800 leading-relaxed">
                Sob a dedicação de <span className="font-semibold">Waleria Mapeli</span>, cada brigadeiro e bombom é cuidadosamente preparado com ingredientes premium, combinando tradição e inovação para criar doces que encantam todos os sentidos.
              </p>
            </div>

            {/* Features grid */}
            <div className="grid grid-cols-2 gap-6">
              {features.map((feature, index) => {
                const Icon = feature.icon;
                return (
                  <div 
                    key={index}
                    className="bg-white rounded-2xl p-6 border-2 border-amber-100 hover:border-amber-300 transition-all duration-300 hover:shadow-lg"
                  >
                    <div className="w-12 h-12 bg-amber-100 rounded-xl flex items-center justify-center mb-4">
                      <Icon className="w-6 h-6 text-amber-700" />
                    </div>
                    <h3 className="font-bold text-amber-950 mb-2">
                      {feature.title}
                    </h3>
                    <p className="text-sm text-amber-700 leading-relaxed">
                      {feature.description}
                    </p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
